"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var constants_1 = require("../../constants");
require("./StatusBar.scss");
var defaults = {
    active: false,
    fileName: '',
    fileSize: constants_1.DEFAULT_FILE_SIZE,
    children: null,
};
/**
 * Display status of file upload
 * @param Props
 * @component
 */
var StatusBar = function (_a) {
    var _b = _a === void 0 ? defaults : _a, active = _b.active, fileName = _b.fileName, fileSize = _b.fileSize, children = _b.children;
    var className = active ? 'active' : 'inactive';
    return (react_1["default"].createElement("div", { className: "statusBar " + className },
        react_1["default"].createElement("div", { className: "statusBar-file" },
            react_1["default"].createElement("span", { className: "statusBar-file-name" }, fileName), "(" + fileSize + ")"),
        react_1["default"].createElement("div", { className: "statusBar-current" }, children)));
};
exports["default"] = StatusBar;
